const keyImamHussain = 'bs__ziarat_imam_hussain';
const keyHazratMassomeh = 'bs__ziarat_hazrat_massomeh';

const getImamHussainData = () => {
    const data = window.localStorage.getItem(keyImamHussain);
    return data ? JSON.parse(data) : [];
}

const setImamHussainData = (data) => {
    window.localStorage.setItem(keyImamHussain, JSON.stringify(data));
}

const addImamHussainData = (value) => {
    let existingData = getImamHussainData();
    existingData.push(value);
    existingData = existingData.filter(onlyUnique);
    setImamHussainData(existingData);
}

const getHazratMassomehData = () => {
    const data = window.localStorage.getItem(keyHazratMassomeh);
    return data ? JSON.parse(data) : [];
}

const setHazratMassomehData = (data) => {
    window.localStorage.setItem(keyHazratMassomeh, JSON.stringify(data));
}

const addHazratMassomehData = (value) => {
    let existingData = getHazratMassomehData();
    existingData.push(value);
    existingData = existingData.filter(onlyUnique);
    setHazratMassomehData(existingData);
}


const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
};

export {
    getImamHussainData,
    setImamHussainData,
    addImamHussainData,
    getHazratMassomehData,
    setHazratMassomehData,
    addHazratMassomehData
}
